import { render } from "./NewPassword.vue?vue&type=template&id=110ee433&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-110ee433"

export default script